document.addEventListener('DOMContentLoaded',()=>{
  // year
  const y=document.getElementById('year'); if(y) y.textContent=new Date().getFullYear();

  // mobile nav
  const nav=document.getElementById('nav');
  const btn=document.getElementById('navToggle');
  if(btn && nav){
    btn.addEventListener('click',()=>nav.classList.toggle('show'));
  }

  // booking form behaviour - POST to /apps or storefront API as needed (keeps same JS)
  const form=document.getElementById('bookingForm');
  const msg=document.getElementById('bookingMsg');
  if(form){
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const data={
        name:form.name.value.trim(),
        email:form.email.value.trim(),
        phone:form.phone.value.trim(),
        service:form.service.value,
        date:form.date.value,
        notes:form.notes.value.trim(),
        createdAt:new Date().toISOString()
      };
      if(!data.name || !data.email){
        msg.textContent='Please provide name and email.'; return;
      }

      try{
        const res=await fetch('/api/bookings',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
        if(res.ok){
          msg.textContent='Thanks — your request was received. We will contact you soon.';
          form.reset();
        }else{
          const txt=await res.text();
          msg.textContent=`Server error: ${res.status} ${txt}`;
        }
      }catch(err){
        msg.textContent='Thanks — demo saved locally. Run the provided server to accept real bookings.';
        form.reset();
      }
    });
  }
});
